import { useEffect, useRef, useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export function AddressAutocomplete({ value = "", onSelect, testid = "address-autocomplete", placeholder = "12 rue des Lilas, Marseille" }) {
  const [q, setQ] = useState(value);
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const timer = useRef();
  const box = useRef();

  useEffect(() => { setQ(value); }, [value]);

  useEffect(() => {
    const onClick = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const search = (text) => {
    setQ(text);
    onSelect({ label: text, lat: null, lon: null });
    clearTimeout(timer.current);
    if (text.trim().length < 3) { setResults([]); return; }
    timer.current = setTimeout(async () => {
      setBusy(true);
      try {
        const res = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(text)}&limit=5`);
        const data = await res.json();
        setResults(data.features || []);
        setOpen(true);
      } catch { setResults([]); } finally { setBusy(false); }
    }, 300);
  };

  const pick = (f) => {
    const label = f.properties.label;
    const [lon, lat] = f.geometry.coordinates;
    setQ(label);
    onSelect({ label, lat, lon });
    setOpen(false);
    setResults([]);
  };

  return (
    <div ref={box} className="relative">
      <MapPin className="absolute left-3 top-3.5 h-4 w-4 text-slate-400" />
      {busy && <Loader2 className="absolute right-3 top-3.5 h-4 w-4 animate-spin text-slate-400" />}
      <Input
        data-testid={testid}
        value={q}
        onChange={(e) => search(e.target.value)}
        onFocus={() => results.length && setOpen(true)}
        placeholder={placeholder}
        className="h-12 rounded-xl pl-9"
        autoComplete="off"
      />
      {open && results.length > 0 && (
        <ul className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-xl border border-slate-200 bg-white py-1 shadow-xl">
          {results.map((f, i) => (
            <li key={i}>
              <button type="button" data-testid={`${testid}-option-${i}`} onClick={() => pick(f)} className="flex w-full items-start gap-2 px-3 py-2 text-left text-sm hover:bg-[#E0F2FE]">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#1D9BF0]" />
                <span className="text-slate-700">{f.properties.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
